import React from 'react';
import { Button, Table} from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import ThreeColumnTableRow from '../CreateCourse/ThreeColumnTableRow';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class SemesterInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            optionalCoursesECTSMin: this.props.semester.optionalCoursesECTSMin,
            optionalCoursesECTSMax: this.props.semester.optionalCoursesECTSMax,
            optionalCoursesNumberMin: this.props.semester.optionalCoursesNumberMin,
            optionalCoursesNumberMax: this.props.semester.optionalCoursesNumberMax,
            edit: false,
            deleteSemester: false
        };
        this.onChange = this.onChange.bind(this);
        this.saveSemesterInfo = this.saveSemesterInfo.bind(this);
        this.deleteSemester = this.deleteSemester.bind(this);
    }

    onChange(keyName, value) {
        this.setState({ [keyName]: value });
    }

    saveSemesterInfo(
        optionalCoursesECTSMin,
        optionalCoursesECTSMax,
        optionalCoursesNumberMin,
        optionalCoursesNumberMax
    ) {
        const { semester } = this.props;
        let studyProgramSemesterId = semester.studyProgramSemester.id;
        let optlock = semester.optLock;
        let id = semester.id;

        let semesterObj = {
            optionalCoursesECTSMin,
            optionalCoursesECTSMax,
            optionalCoursesNumberMin,
            optionalCoursesNumberMax,
            studyProgramSemesterId,
            optlock,
            id
        };
        if (!optionalCoursesECTSMin || !optionalCoursesECTSMax || !optionalCoursesNumberMin || !optionalCoursesNumberMax || !studyProgramSemesterId) {
            toast('Niste unijeli sva obavezna polja!');
            if (!optionalCoursesECTSMin) { this.setState({ optionalCoursesECTSMinErr: true }); } else { this.setState({ optionalCoursesECTSMinErr: false }); }
            if (!optionalCoursesECTSMax) { this.setState({ optionalCoursesECTSMaxErr: true }); } else { this.setState({ optionalCoursesECTSMaxErr: false }); }
            if (!optionalCoursesNumberMin) { this.setState({ optionalCoursesNumberMinErr: true }); } else { this.setState({ optionalCoursesNumberMinErr: false }); }
            if (!optionalCoursesNumberMax) { this.setState({ optionalCoursesNumberMaxErr: true }); } else { this.setState({ optionalCoursesNumberMaxErr: false }); }
            if (!studyProgramSemesterId) { this.setState({ semesterErr: true }); } else { this.setState({ semesterErr: false }); }
        } else if (parseInt(optionalCoursesECTSMin,10) > parseInt(optionalCoursesECTSMax,10)) {
            toast('Maksimalna vrijednost mora biti veća od minimalne vrijendosti!');
            this.setState({
                optionalCoursesECTSMinErr: true,
                optionalCoursesECTSMaxErr: true
            });
        } else if (parseInt(optionalCoursesNumberMin,10) > parseInt(optionalCoursesNumberMax,10)) {
            toast('Maksimalna vrijednost mora biti veća od minimalne vrijendosti!');
            this.setState({
                optionalCoursesNumberMinErr: true,
                optionalCoursesNumberMaxErr: true
            });
        } else {
            axios.put('study-programs/semesters/', { ...semesterObj })
                .then(res => {
                    this.setState({
                        optionalCoursesECTSMin: null,
                        optionalCoursesECTSMax: null,
                        optionalCoursesNumberMin: null,
                        optionalCoursesNumberMax: null,
                    });
                    this.props.getSemesters(false, true, this.props.activeIndex);
                })
                .catch(err => {
                    toast('Došlo je do greške! Dodavanje informacija o semestru nije uspjelo.');
                });

            this.setState({ edit: false });
        }
    }

    deleteSemester() {
        let obj = { id: this.props.semester.id };
        axios.delete('study-programs/remove-semester', { data: obj })
            .then(res => {
                this.props.getSemesters(true, false);
                this.setState({ deleteSemester: false });
            })
            .catch(err => {
                toast('Došlo je greške! Brisanje semestra nije uspjelo.');
            });
    }

    render() {
        const { semester } = this.props;
        return (
            <div>
                <Table celled unstackable compact>
                    <Table.Header>
                        <Table.Row>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        <ThreeColumnTableRow
                            type='number'
                            name="Minimalan broj ECTS bodova za izborne predmete"
                            keyName="optionalCoursesECTSMin"
                            value={semester.optionalCoursesECTSMin}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={semester.optionalCoursesECTSMin}
                        />
                        <ThreeColumnTableRow
                            type='number'
                            name="Maksimalan broj ECTS bodova za izborne predmete"
                            keyName="optionalCoursesECTSMax"
                            value={semester.optionalCoursesECTSMax}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={semester.optionalCoursesECTSMax}
                        />
                        <ThreeColumnTableRow
                            type='number'
                            name="Minimalan broj izbornih predmeta"
                            keyName="optionalCoursesNumberMin"
                            value={semester.optionalCoursesNumberMin}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={semester.optionalCoursesNumberMin}
                        />
                        <ThreeColumnTableRow
                            type='number'
                            name="Maksimalan broj izbornih predmeta"
                            keyName="optionalCoursesNumberMax"
                            value={semester.optionalCoursesNumberMax}
                            onChange={this.onChange}
                            edit={this.state.edit}
                            defValue={semester.optionalCoursesNumberMax}
                        />
                    </Table.Body>
                </Table>
                {(!this.state.edit && !this.state.deleteSemester && !this.props.studentService) ?
                    <div>
                        {(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') && (localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta') && <Button floated="right" color="red" basic="true" onClick={() => this.setState({ deleteSemester: true })}>Obriši semestar</Button>}
                        {(localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') && (localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta') && <Button floated="right" color="green" basic="true" onClick={() => this.setState({
                            edit: true,
                            optionalCoursesECTSMin: semester.optionalCoursesECTSMin,
                            optionalCoursesECTSMax:semester.optionalCoursesECTSMax,
                            optionalCoursesNumberMin:semester.optionalCoursesNumberMin,
                            optionalCoursesNumberMax: semester.optionalCoursesNumberMax })}>
                            Izmijeni</Button>}</div>
                    : this.state.deleteSemester ?
                        <div style={{ float: 'right' }}>
                            <h4>Jeste li sigurni?</h4>
                            <Button.Group >
                                <Button
                                    basic="true"
                                    color="red"
                                    onClick={this.deleteSemester}
                                > Obriši semestar</Button>
                                <Button
                                    basic="true"
                                    color="blue"
                                    onClick={() => { this.setState({ deleteSemester: false }); }}
                                >  Odustani

                                </Button>
                            </Button.Group></div>
                        : !this.props.studentService ? <div><Button floated="right" basic="true" color="blue" onClick={() => this.setState({ edit: false })}>Odustani</Button>
                            <Button
                                floated="right"
                                primary
                                onClick={() => this.saveSemesterInfo(
                                    this.state.optionalCoursesECTSMin,
                                    this.state.optionalCoursesECTSMax,
                                    this.state.optionalCoursesNumberMin,
                                    this.state.optionalCoursesNumberMax
                                )}
                            >
                          Sačuvaj izmjene</Button>
                            <ToastContainer hideProgressBar />
                        </div>
                            : null}

                <ToastContainer hideProgressBar />
            </div>

        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgram/SemesterInfo.js